export const IS_DEV = window.location.host.includes('dev');

export const baseUrl = `https://${IS_DEV ? 'dev-app-priv' : 'app'}.practicemojo.com/cgi-bin/WebObjects/PracticeMojoAPI.woa/booking/`